// src/features/my-shift/lockState.ts
import type { Shift } from "@/features/shift/types";
import type { ShiftRequest } from "@/features/shift-request/types";
import { getShiftStartEnd } from "@/features/shift/types";
import { format } from "date-fns";
import { scheduleDateOf } from "./calendar";

export type LockReason = "past" | "approved_leave" | null;
export interface LockState { isLocked: boolean; reason: LockReason; }

export function computeLockState(
  shift: Shift,
  requests: ShiftRequest[],
  now: Date = new Date(),
): LockState {
  // 1) approved leave 优先
  const approvedLeave = requests.find((r) => {
    const sid = r.scheduleId || r.schedule_id;
    const type = r.requestType || r.request_type;
    return !!sid && sid === shift.id && type === "leave" && r.status === "approved";
  });
  if (approvedLeave) return { isLocked: true, reason: "approved_leave" };

  // 2) 过去日期
  const dateStr = scheduleDateOf(shift);
  const todayStr = format(now, "yyyy-MM-dd");
  if (dateStr && dateStr < todayStr) return { isLocked: true, reason: "past" };

  // 3) 今天且已开始
  if (dateStr === todayStr) {
    const { startAt } = getShiftStartEnd(shift);
    if (startAt) {
      const start = new Date(startAt);
      if (!isNaN(start.getTime()) && start.getTime() <= now.getTime()) {
        return { isLocked: true, reason: "past" };
      }
    }
  }
  return { isLocked: false, reason: null };
}
